export interface NameDto<T = number> {
  id: T
  name: string
}

export const isName = <T>(name: unknown): name is NameDto<T> => {
  return typeof name === 'object' && name !== null && 'name' in name
}

export interface ShortNameDto<T = number> {
  id: T
  shortName: string
  name: string
}
